import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toGuidOrNull, toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { TaskCollection } from '../index'
import { dateTypeToString, stringToDateType } from '@/lib/types/dateType'

export const setupTaskReplication = (
  collection: TaskCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'tasks',
    displayName: 'Task',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      projectId: doc.projectId,
      seqNo: doc.seqNo ?? null,
      identifier: doc.identifier ?? null,
      name: doc.name,
      statusId: doc.statusId,
      userId: doc.userId,
      accountableUserId: doc.accountableUserId ?? null,
      priority: doc.priority ?? 0,
      dueDate: toTimestamp(doc.dueDate),
      dueDateType: dateTypeToString(doc.dueDateType),
      startDate: toTimestamp(doc.startDate),
      startDateType: dateTypeToString(doc.startDateType),
      isAllDay: doc.isAllDay ?? false,
      sortOrder: doc.sortOrder,
      estimation: doc.estimation ?? null,
      isSomeday: doc.isSomeday || false,
      isDeleted: doc.isDeleted || false,
      isArchived: doc.isArchived || false,
      parentId: doc.parentId,
      workItemTypeId: doc.workItemTypeId ?? null,
      coverImageUrl: doc.coverImageUrl ?? null,
      coverImageType: doc.coverImageType ?? null,
      coverImageMeta: doc.coverImageMeta ?? null,
      statusName: doc.statusName || '',
      statusColor: doc.statusColor || '#gray',
      userName: doc.userName,
      userEmail: doc.userEmail ?? null,
      accountableUserName: doc.accountableUserName ?? null,
      accountableUserEmail: doc.accountableUserEmail ?? null,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
      archivedOn: doc.archivedOn ? (toTimestamp(doc.archivedOn) ?? new Date(doc.archivedOn).getTime()) : null,
      archivedBy: doc.archivedBy,
      aiGate: doc.aiGate ?? null,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      projectId: state.projectId || null,
      name: state.name,
      statusId: state.statusId,
      userId: state.userId || null,
      accountableUserId: state.accountableUserId || null,
      priority: state.priority,
      dueDate: toISOStringOrNull(state.dueDate),
      dueDateType: stringToDateType(state.dueDateType),
      startDate: toISOStringOrNull(state.startDate),
      startDateType: stringToDateType(state.startDateType),
      isAllDay: state.isAllDay ?? false,
      sortOrder: state.sortOrder || null,
      estimation: state.estimation ?? null,
      isSomeday: state.isSomeday,
      isDeleted: state.isDeleted,
      isArchived: state.isArchived,
      parentId: state.parentId || null,
      workItemTypeId: toGuidOrNull(state.workItemTypeId),
      coverImageUrl: state.coverImageUrl || null,
      coverImageType: state.coverImageType || null,
      coverImageMeta: state.coverImageMeta || null,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy || null,
      archivedOn: toISOStringOrNull(state.archivedOn),
      archivedBy: state.archivedBy || null,
      aiGate: state.aiGate ?? null,
    }),
  })
